import { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import fetchDocProfiles, { DataEntity } from '../api/fetchDocProfiles';
import switchDoctor from '../api/switchDoctor';
import { INIT } from '../routes/paths';
import { dispatch } from '../bridge/events/dispatch';
import { flushPatientFuseInstance } from './allPatientsIndex';
// import { changeDoc } from '../store/idbHandler';

const ChangeDoc2: React.FC = () => {
    const [doctors, setDoctors] = useState<DataEntity[]>();
    const [fetchState, setFetchState] = useState<'loading' | 'success' | 'error'>('loading');

    const history = useHistory();

    useEffect(() => {
        setFetchState('loading');
        fetchDocProfiles()
            .then((response) => {
                if (response.success) {
                    setFetchState('success');
                    setDoctors(response.data || []);
                }
                setFetchState('error');
            })
            .catch((e) => {
                console.log(e), setFetchState('error');
            });
    }, []);

    const onDocSelect = (docId: string) => {
        setFetchState('loading');
        switchDoctor(docId)
            .then(() => {
                flushPatientFuseInstance();
                dispatch({
                    type: 'DR_SWITCH_EVENT',
                });
                history.replace(INIT);
            })
            .catch(console.error);
        // changeDoc(docId);
        // history.push(GO_TO_STAFF_SETUP_APP);
    };

    if (fetchState === 'loading') {
        return (
            <div className="flex flex-col items-center justify-center w-screen h-screen space-y-64">
                <div className="pulse">
                    <svg width="16px" height="12px">
                        <polyline id="back" points="1 6 4 6 6 11 10 1 12 6 15 6"></polyline>
                        <polyline id="front" points="1 6 4 6 6 11 10 1 12 6 15 6"></polyline>
                    </svg>
                </div>
            </div>
        );
    }

    return (
        <div className="flex flex-col w-screen h-full font-lato bg-neutral-9 overflow-hidden">
            <div className="modal-overlay"></div>
            <div className="flex w-30p z-10 modal-content max-h-4/5 rounded-8 overflow-hidden">
                <div className="w-full">
                    <div className="bg-background-action-states-white rounded-32 space-y-16 md:space-y-24 h-full flex flex-col flex-auto flex-1">
                        <span>
                            <div className="flex items-center justify-between p-16 bg-neutral-9 rounded-t-8">
                                <p className="font-700 text-neutral-1 text-18">Select a Doctor</p>
                            </div>

                            <div className="w-full border-b border-neutral-7"></div>
                        </span>
                        <div className="flex-1 overflow-auto px-24 pb-24 h-full tbody-fade-bg">
                            {doctors?.map((d) => (
                                <div>
                                    <div
                                        key={d._id}
                                        onClick={() => onDocSelect(d._id)}
                                        className="cursor-pointer md:p-16 py-16 flex flex-row space-x-12 items-center "
                                    >
                                        <div className="overflow-hidden h-48 w-48 rounded-8 rounded-12 ">
                                            <img
                                                src={d.pic}
                                                // alt={d.profile.personal.name.f}
                                            />
                                        </div>
                                        <div className="flex flex-col flex-1 space-y-4">
                                            <div className="font-700 text-neutral-black text-18 capitalize">
                                                Dr. {[d.name.f, d.name.l].filter(Boolean).join(' ')}
                                            </div>
                                            <div className="text-neutral-4 text-14">
                                                {d.specialized}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ChangeDoc2;
